export default __webpack_public_path__ + "static/media/logo.bde6bd19.png";